import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import b2blogo from "../../Asserts/Images/b2blogoo.webp";
import levon_logo from "../../Asserts/Images/levon-techno_logo.webp";
import "./taxinvoice.css";
import { IoIosGlobe } from "react-icons/io";
import { LuPhoneCall } from "react-icons/lu";
import Instance from "../../AxiosConfig";
import { message, Spin } from "antd";
import b2b_seal from "../../Asserts/Images/B2B seal.webp";
import Levon_seal from "../../Asserts/Images/levon seal .webp";
import numberToWords from "number-to-words";
import { ToWords } from "to-words";

const TaxInvoicePage = (props) => {
  const { id: paramId, termId: paramTermId } = useParams();
  const id = props.id || paramId;
  const termId = props.termId || paramTermId;

  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);

  const formatDateDDMMYYYY = (dateString) => {
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: false,
      ignoreDecimal: true,
      doNotAddOnly: true,
    },
  });
  const handleTaxInvoicePage = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await Instance.get(`/invoices/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        const invoice = response.data?.invoice;
        setInvoiceData(invoice);
        // console.log("Fetched invoice:", invoice);
      } else {
        message.error("Failed to fetch invoice data");
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
      message.error("Error fetching invoice");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) handleTaxInvoicePage();
  }, [id]);

  if (loading || !invoiceData) {
    return (
      <div className="text-center mt-5">
        <Spin size="large" />
        <p>Loading Invoice...</p>
      </div>
    );
  }

  const {
    invoiceNo,
    companyDetails,
    companyName,
    address,
    email,
    phone,
    country,
    city,
    ClientName,
    SacCode,
    certificationType,
    termTotal,
    gstNumber,
    currency,
    terms = [],
    baseClosureAmount,
    isSplitTax,
  } = invoiceData;

  const hasFinalRow = currency === "INR"; // strict comparison
  const selectedTerm = terms.find((t) => t._id === termId);
  const termsToShow = termId && selectedTerm ? [selectedTerm] : terms;

  if (termId && !selectedTerm) {
    return (
      <div className="invoice-container text-center p-5">
        <h3>Term not found or not paid</h3>
        <p>Please check the invoice again.</p>
      </div>
    );
  }

  const totalAmount = termsToShow.reduce(
    (acc, term) => acc + (term?.termTotal || 0),
    0,
  );

  // const amountInWords = numberToWords
  //   .toWords(totalAmount)
  //   .replace(/\b\w/g, (l) => l.toUpperCase());

  const amountInWords = toWords
    .convert(totalAmount)
    .replace(/\b\w/g, (l) => l.toUpperCase());

  return (
    <div className="invoice-container">
      <div className="invoice-content">
        <div className="tax-invoice-header">
          <div className="contact-details">
            <h6>
              <IoIosGlobe /> www.b2bcert.com
            </h6>
            <h6>
              <LuPhoneCall /> +91 8618629303
            </h6>
          </div>

          <div>
            <img className="b2b-logo" src={b2blogo} alt="B2B Logo" />
          </div>

          <div className="header-title">
            <h5>A Division Of</h5>
          </div>

          <div>
            <img className="b2b-logo" src={levon_logo} alt="Levon Logo" />
          </div>

          <div className="contact-details">
            <h6>
              <IoIosGlobe /> www.levon-global.com
            </h6>
            <h6>
              <LuPhoneCall /> +91 8618629303
            </h6>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <h6 style={{ fontSize: "16px", fontWeight: "700" }}>
            Date:{" "}
            <span style={{ color: "grey", fontWeight: "500" }}>
              {formatDateDDMMYYYY(invoiceData.InvoiceDate)}
            </span>
          </h6>
        </div>

        <h2 className="invoice-title">TAX INVOICE: {invoiceNo}</h2>

        <div className="invoice-section">
          <div className="invoice-box">
            <div className="invoice-header">Bill From</div>
            <div className="invoice-body">
              <h4>{companyDetails?.companyName}</h4>
              <p>
                {companyDetails?.addressLine1}, {companyDetails?.addressLine2},{" "}
                {companyDetails?.city}, {companyDetails?.state} -{" "}
                {companyDetails?.pincode}
              </p>
              <p>
                <a href={`mailto:${companyDetails?.email}`}>
                  {companyDetails?.email}
                </a>
              </p>
              <p>
                <strong>{companyDetails?.phone}</strong>
              </p>
              <p>{companyDetails?.gstNumber}</p>
            </div>
          </div>

          <div className="invoice-box">
            <div className="invoice-header">Bill To</div>
            <div className="invoice-body">
              <h4>{companyName}</h4>
              <p>
                {address}, {city}, {country}
              </p>
              <p>{ClientName}</p>
              <p>
                <a href={`mailto:${email}`}>{email}</a>
              </p>
              <p>
                <strong>{phone}</strong>
              </p>
              <p>{gstNumber}</p>
            </div>
          </div>
        </div>

        {/* Table */}
        <table className="invoice-table mt-4">
          <thead className="table-head">
            <tr>
              <th>SL. No.</th>
              <th>Description</th>
              <th>SAC Code</th>
              <th>Price ({currency})</th>
              <th>Total (INR)</th>
            </tr>
          </thead>

          <tbody>
            {termsToShow.map((term, index) => {
              const rowsPerTerm = isSplitTax ? 5 : 4;

              const mainSerial = index * rowsPerTerm + 1;
              const balanceSerial = mainSerial + 1;
              const finalSerial = mainSerial + 2;

              const hasBalanceRow = term.status === "Paid" || "Pending";

              return (
                <React.Fragment key={term._id}>
                  <tr>
                    <td
                      data-label="SL. No."
                      style={{ fontWeight: "600", backgroundColor: "#f9f9f9" }}
                    >
                      {mainSerial}
                    </td>
                    <td data-label="Description" style={{ fontWeight: "600" }}>
                      {certificationType}
                    </td>
                    <td data-label="SAC Code" className="text-bold">
                      {SacCode || "—"}
                    </td>
                    <td data-label="Price">
                      {baseClosureAmount?.toLocaleString()} {currency}
                    </td>
                    <td data-label="Total" style={{ fontWeight: "700" }}></td>
                  </tr>

                  {hasBalanceRow && (
                    <tr style={{ backgroundColor: "#f0f8ff" }}>
                      <td data-label="SL. No.">{balanceSerial}</td>
                      <td data-label="Description">
                        <span>{term.termName}</span>
                      </td>
                      <td data-label="SAC Code" className="text-bold"></td>
                      <td data-label="Price">
                        {term.baseAmount?.toLocaleString()} {currency}
                      </td>
                      <td data-label="Total">
                        {term.baseAmount?.toLocaleString()} {currency}
                      </td>
                    </tr>
                  )}

                  {/* ROW 3: FINAL SETTLEMENT (NEW ROW!) */}
                  {/* GST ROW */}
                  {hasFinalRow && (
                    <>
                      {!isSplitTax ? (
                        <tr style={{ backgroundColor: "#e6f7ff" }}>
                          <td data-label="SL. No.">{finalSerial}</td>

                          <td data-label="Description">
                            <span>
                              IGST {term.gstPercentage || 18}%
                            </span>
                          </td>

                          <td data-label="SAC Code" className="text-bold">
                            -
                          </td>

                          <td data-label="Price">
                            {Number(term.gstAmount || 0).toLocaleString()} {currency}
                          </td>

                          <td data-label="Total">
                            {Number(term.gstAmount || 0).toLocaleString()} {currency}
                          </td>
                        </tr>
                      ) : (
                        <>
                          {/* CGST */}
                          <tr style={{ backgroundColor: "#e6f7ff" }}>
                            <td data-label="SL. No.">{finalSerial}</td>

                            <td data-label="Description">
                              <span>
                                CGST {(term.gstPercentage || 18) / 2}%
                              </span>
                            </td>

                            <td data-label="SAC Code" className="text-bold">
                              -
                            </td>

                            <td data-label="Price">
                              {(Number(term.gstAmount || 0) / 2).toLocaleString()} {currency}
                            </td>

                            <td data-label="Total">
                              {(Number(term.gstAmount || 0) / 2).toLocaleString()} {currency}
                            </td>
                          </tr>

                          {/* SGST */}
                          <tr style={{ backgroundColor: "#e6f7ff" }}>
                            <td data-label="SL. No.">{finalSerial + 1}</td>

                            <td data-label="Description">
                              <span>
                                SGST {(term.gstPercentage || 18) / 2}%
                              </span>
                            </td>

                            <td data-label="SAC Code" className="text-bold">
                              -
                            </td>

                            <td data-label="Price">
                              {(Number(term.gstAmount || 0) / 2).toLocaleString()} {currency}
                            </td>

                            <td data-label="Total">
                              {(Number(term.gstAmount || 0) / 2).toLocaleString()} {currency}
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  )}
                  {/* TOTAL GST */}
                  {hasFinalRow && (
                    <tr style={{ backgroundColor: "#d9f7be" }}>
                      <td data-label="SL. No.">
                        {isSplitTax ? finalSerial + 2 : finalSerial + 1}
                      </td>

                      <td data-label="Description">
                        <strong>Total GST</strong>
                      </td>

                      <td data-label="SAC Code" className="text-bold">
                        -
                      </td>

                      <td data-label="Price">
                        {Number(term.gstAmount || 0).toLocaleString()} {currency}
                      </td>

                      <td data-label="Total">
                        {Number(term.gstAmount || 0).toLocaleString()} {currency}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}

            <tr className="total-section">
              <td
                colSpan="4"
                className="text-right text-bold"
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  textAlign: "center",
                }}
              >
                GRAND TOTAL
              </td>
              <td className="text-bold" style={{ fontSize: "20px" }}>
                {totalAmount?.toLocaleString()} {currency}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="amount-section">
          <span>
            <strong>Amount in words:</strong> {amountInWords} {currency}
          </span>
        </div>

        {/* Bank Details */}
        <div className="mt-3 payment-term">
          <h5>Payment Terms :</h5>
          <h4>Bank Transfer Details</h4>
          <div className="mt-4 payment-term-content">
            <div>
              {/* Bank Info */}
              <p>
                <strong>Bank:</strong> {invoiceData?.selectedBank?.bankName}
              </p>

              <p>
                <strong>Account Number:</strong>{" "}
                {invoiceData?.selectedBank?.accountNumber}
              </p>

              <p>
                <strong>Country:</strong>{" "}
                {invoiceData?.selectedBank?.country || "India"}
              </p>

              {/* ✅ INDIA CASE */}
              {invoiceData?.selectedBank?.country === "India" ? (
                <>
                  <p>
                    <strong>IFSC Code:</strong>{" "}
                    {invoiceData?.selectedBank?.ifscCode || "-"}
                  </p>

                  <p>
                    <strong>Beneficiary Name:</strong>{" "}
                    {invoiceData?.selectedBank?.beneficiaryName || "-"}
                  </p>

                  <p>
                    <strong>SWIFT Code:</strong>{" "}
                    {invoiceData?.selectedBank?.swiftCode || "-"}
                  </p>

                  <p>
                    <strong>Bank Address:</strong>{" "}
                    {invoiceData?.selectedBank?.branchAddress || "-"}
                  </p>
                </>
              ) : (
                /* ✅ INTERNATIONAL CASE */
                <>
                  <p>
                    <strong>Account Holder:</strong>{" "}
                    {invoiceData?.selectedBank?.accountHolderName || "-"}
                  </p>

                  <p>
                    <strong>Routing Code:</strong>{" "}
                    {invoiceData?.selectedBank?.routingCode || "-"}
                  </p>

                  <p>
                    <strong>Routing Type:</strong>{" "}
                    {invoiceData?.selectedBank?.routingType || "-"}
                  </p>

                  <p>
                    <strong>Payment Method:</strong>{" "}
                    {invoiceData?.selectedBank?.paymentMethod || "-"}
                  </p>

                  <p>
                    <strong>Bank Address:</strong>{" "}
                    {invoiceData?.selectedBank?.bankAddress || "-"}
                  </p>
                </>
              )}
            </div>

            <div className="seal-section">
              <img className="seal-img" src={b2b_seal} alt="B2B Seal" />
              <img className="seal-img" src={Levon_seal} alt="Levon Seal" />
            </div>
          </div>

          {currency !== "INR" && (
            <h6 className="important-note">
              Important Note:{" "}
              <span>
                1) Remittance should not be made in INR | 2) IGST exempted on
                execution of LUT
              </span>
            </h6>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaxInvoicePage;
